import React from "react";
import TableHeadFormik from "./TableHeadFormik";
import TableBodyFormik from "./TableBodyFormik";
import { useFormikContext } from "formik";
import { Alert, Button, Grid } from "@mui/material";
import { useEffect } from "react";
import styled from "styled-components";
//import Table from "@mui/material/Table";
import { useState } from "react";
import { handleCopySecondarySize } from "../../CommonFuntion/TableBodyFormikHelper";
import { getMessage } from "../../CommonFuntion/messages";
import SnackbarAlert from "./SnackbarAlert";
function EnhancedTableToolbar(props) {
  const { name, label } = props;
  const { errors } = useFormikContext();
  // Only show total quantity error if this table has qty fields and its total is zero
  const tableTotals = (typeof window !== "undefined" && window.__tableTotals) || {};
  const showTotalQtyError = Boolean(
    errors[name + "_Total_Label"] &&
    tableTotals[name] &&
    tableTotals[name].hasQty === true &&
    tableTotals[name].totalZero === true
  );
  return (
    <>
      {errors[name + "_Label"] && (
        <Alert severity="error">
          <span> {errors[name + "_Label"]} </span>
        </Alert>
      )}
      {showTotalQtyError && (
        <Alert severity="error">
          <span> {errors[name + "_Total_Label"]} </span>
        </Alert>
      )}
      <u>
        <b>{label}:</b>
      </u>
    </>
  );
}
let Table = styled.table``;
export function TableFormik(props) {
  const {
    orientation,
    prefix,
    searchParams,
    SetcatalogueChildOptn,
    catalogueChildOptn,
    handleELLValue,
    handleELLVSchemaItem,
  } = props;

  const [totalSum, setTotalSum] = useState(0);
  const [totalInputSum, setTotalInputSum] = useState(0);
  const [purchasedQty, setPurchasedQty] = useState([]);
  const [secondColumnLeft, setSecondColumnLeft] = useState(0);
  const [columnsWithAnyData, setColumnsWithAnyData] = useState([]);
  props = {
    ...props,
    purchasedQty,
    totalSum,
    setTotalSum,
    setPurchasedQty,
    totalInputSum,
    setTotalInputSum,
    columnsWithAnyData,
  };
  const { values, setFieldValue, setValues } = useFormikContext();
  const [ELCDropDown2, setELCDropDown2] = useState();
  const [copySnackbarOpen, setCopySnackbarOpen] = useState(false);

  const elcSecondaryFields = (props.schemaPageFields || []).filter(
    (f) => f.prefix === "ELC" && f.hasChildList === false
  );
  const elcParentFields = (props.schemaPageFields || []).filter(
    (f) => f.prefix === "ELC" && f.hasChildList === true
  );
  const showCopySecondarySize =
    props.copySecondarySizeEnabled === true &&
    elcSecondaryFields.length > 0 &&
    elcParentFields.length > 0;

  const handleCopySizes = () => {
    handleCopySecondarySize({
      values,
      name: props.name,
      setValues,
      schemaPageFields: props.schemaPageFields || [],
      schemaPageId: props.schemaPageId,
      itemId: props.itemId,
      schemaResult: props.schemaResult,
    });
    setCopySnackbarOpen(true);
  };

  useEffect(() => {
    // Function to determine hidden columns based on undefined values
    const determineColumnsWithAnyData = () => {
      if (props?.formData?.[props.name]?.length > 0) {
        const firstRow = props.formData[props.name][0];
        const columnsWithData = [];
        // Loop through each column
        Object.keys(firstRow).forEach((column) => {
          // Check if column has data in ANY row
          if (
            props.formData[props.name].some(
              (row) => row[column] !== null && row[column] !== undefined
            )
          ) {
            columnsWithData.push(column);
          }
        });

        setColumnsWithAnyData(columnsWithData);
      }
    };

    determineColumnsWithAnyData();

    const updateSecondColumnLeft = () => {
      setTimeout(() => {
        const table = document.getElementById("myTable");
        const cell = table?.querySelector("thead th:nth-child(1)");
        const rect = cell?.getBoundingClientRect();
        const secondColumnWidth = rect?.width;
        setSecondColumnLeft(secondColumnWidth);
      }, 100); // Adjust delay as needed
    };

    if (props.csvUplaodEnabled) {
      Table = styled.table`
        /* Sticky Header */
        thead th:nth-child(1),
        thead th:nth-child(2) {
          position: sticky;
          top: 0;
          //background-color: white;
          z-index: 2; /* Ensure it's above the tbody */
        }

        /* Sticky Left Column */
        tbody td:nth-child(1),
        tbody td:nth-child(2) {
          position: sticky;
          background-color: white;
          z-index: 1;
        }

        /* Odd Rows Background */
        tbody tr:nth-child(odd) td {
          background-color: rgb(239, 232, 219);
        }

        /* First Column Left Position */
        th:nth-child(1),
        td:nth-child(1) {
          left: 0;
        }

        /* Second Column Left Position */
        th:nth-child(2),
        td:nth-child(2) {
          left: ${(props) =>
            props.secondColumnLeft}px; /* Dynamic left position for the second column */
        }
      `;
      window.addEventListener("resize", updateSecondColumnLeft);
      updateSecondColumnLeft();

      return () => {
        window.removeEventListener("resize", updateSecondColumnLeft);
      };
    }
  }, [props.formData]);
  // Notify global flag for OEForm validation
  useEffect(() => {
    // mark whether current table total is zero (kept for backward compat but overridden by per-table map)
    window.__tableTotals = window.__tableTotals || {};
    window.__tableTotals[props.name] = {
      ...(window.__tableTotals[props.name] || {}),
      totalZero: totalSum === 0,
    };
  }, [totalSum, props.name]);

  return (
    <>
      <div className="tableformik">
        <EnhancedTableToolbar {...props} />
        {showCopySecondarySize && (
          <div style={{ margin: "8px 0" }}>
            <Button variant="outlined" size="small" onClick={handleCopySizes}>
              {getMessage("btnCopySecondarySize")}
            </Button>
          </div>
        )}
        <Grid maxWidth="sm">
          <Table id="myTable" secondColumnLeft={secondColumnLeft}>
            {orientation === 0 && (
              <TableHeadFormik
                {...props}
                columnsWithAnyData={columnsWithAnyData}
                setELCDropDown={props.setELCDropDown}
                ELCDropDown={props.ELCDropDown}
              ></TableHeadFormik>
            )}
            <TableBodyFormik
              {...props}
              columnsWithAnyData={columnsWithAnyData}
              setELCDropDown={props.setELCDropDown}
              ELCDropDown={props.ELCDropDown}
              toggleTescoFileUploaded={props.toggleTescoFileUploaded}
              SetcatalogueChildOptn={SetcatalogueChildOptn}
              catalogueChildOptn={catalogueChildOptn}
              handleELLValue={handleELLValue}
              handleELLVSchemaItem={handleELLVSchemaItem}
            ></TableBodyFormik>
          </Table>
        </Grid>
      </div>
      <SnackbarAlert
        open={copySnackbarOpen}
        message={getMessage("copySecondarySizeSuccess")}
        severity="info"
        autoHideDuration={8000}
        onClose={() => setCopySnackbarOpen(false)}
      />
    </>
  );
}
